import { ABSERVICE_EXPERIMENTS } from "@anydo/ab-service";
import {
  ABSERVICE_CLIENT_ID_LS_KEY,
  ABSERVICE_URL,
  HttpError,
  createSingleEventEmitter,
  getPlatformForApi,
} from "@anydo/core";
import { FEATURE_NO_AB_EXPERIMENTS } from "@anydo/features";
import { AbServiceExperimentT, AbServiceExperimentsResultT, DeepReadonlyT, IAbService } from "@anydo/interfaces";
import { isPlainObject } from "lodash";

export class AbService implements IAbService {
  #clientId: string;
  #experiments: AbServiceExperimentT[];
  #updateEvent = createSingleEventEmitter();

  constructor(private readonly storage: Storage) {
    this.#clientId = this.storage.getItem(ABSERVICE_CLIENT_ID_LS_KEY) ?? "";
    this.#experiments = [];
  }

  onExperimentsUpdate = this.#updateEvent.on;

  reset(): void {
    this.#clientId = "";
    this.#experiments = [];
    this.#updateEvent.emit();
  }

  get experiments(): DeepReadonlyT<AbServiceExperimentT[]> {
    return this.#experiments;
  }

  setExperiments(experiments: DeepReadonlyT<AbServiceExperimentT[]>, clientId: string) {
    if (FEATURE_NO_AB_EXPERIMENTS) return;

    this.#clientId = clientId;
    this.storage.setItem(ABSERVICE_CLIENT_ID_LS_KEY, clientId);

    this.#experiments = experiments.filter((experiment) => {
      return (
        experiment != null &&
        typeof experiment.name === "string" &&
        typeof experiment.group === "string" &&
        isPlainObject(experiment.properties)
      );
    });
    this.#updateEvent.emit();
  }

  async fetchFromServer(email: string) {
    if (FEATURE_NO_AB_EXPERIMENTS) return;

    const url = new URL(ABSERVICE_URL);

    url.searchParams.set("platform", getPlatformForApi());
    url.searchParams.set("client_id", this.#clientId);
    url.searchParams.set("email", email);
    url.searchParams.set("required_experiments", JSON.stringify(ABSERVICE_EXPERIMENTS));

    // fixme: node-fetch does not accept URLs
    const res = await fetch(url.toString());
    if (!res.ok) {
      throw new HttpError(res, 0, await res.text());
    }

    const { experiments, client_id } = (await res.json()) as AbServiceExperimentsResultT;
    this.setExperiments(experiments, client_id);
  }
}
